import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-asociar-radicado',
  templateUrl: './asociar-radicado.component.html',
  styleUrls: ['./asociar-radicado.component.scss']
})
export class AsociarRadicadoComponent implements OnInit, AfterViewInit, OnDestroy {

  /**
   * Variables DataTable
   */
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective, {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  newForm: FormGroup;
  public selected_tab: number;
  public empresa: string;

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   * @param {MatDialogRef<AsociarRadicadoComponent>} _dialog 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) public _data,
    private _cartera: CarteraService,
    public _dialog: MatDialogRef<AsociarRadicadoComponent>
  ) 
  { 
    this.newForm = this.createForm();
    this.selected_tab = 0;
    this.empresa = _data.Database === 'medisoft' ? 'Red Médica Vital' : 'VitalMascotas';
    this.dtTrigger = new Subject();
    this.dtTrigger.next();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this.dtOptions = {
      order: [2, 'desc'],
      scrollCollapse: true,
      language: {
        lengthMenu: "_MENU_ Registros por página",
        zeroRecords: "Persona inexistente en el sistema",
        info: "Mostrando la página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(Filtrado de _MAX_ registros totales)",
        LoadingRecords: "Cargando...",
        search: "Buscar:",
        paginate: {
          first:   "Primero",
          last:    "Último",
          next:    "Siguiente",
          previous:"Anterior" 
        }
      },
      columns: [
        {
          title: '',
          orderable: false
        },
        {
          title: 'Empresa',
          data: 'empresa'
        },
        {
          title: 'Documento',
          data: 'documento_grupo'
        },
        {
          title: 'Radicado',
          data: 'radicado_grupo'
        },
        {
          title: 'Nombre Completo',
          data: 'nombre_grupo'
        }
      ]
    }
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // ----------------------------------------------------------------------------------------------------

  /**
   * Creación FormGroup
   * @returns {FormGroup}
   */
  createForm(): FormGroup {
    return new FormGroup({
      documento: new FormControl(null, [
        Validators.pattern('[A-Za-z0-9]+')
      ]),
      radicado: new FormControl(null, [
        Validators.pattern('[A-Za-z0-9]+')
      ]),
      nombre: new FormControl(null, [
        Validators.pattern('[A-Za-z ]+')
      ])
    });
  }

  /**
   * Renderiza la tabla
   */
  public renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    })
  }

  /**
   * Busca el grupo
   * @param {any} form 
   */
  public buscarGrupo(form: any): void {
    const setVariable: string = this.selected_tab === 0 ? form.documento : this.selected_tab === 1 ? form.radicado : form.nombre;
    this._cartera.VerGruposAsociar(this._data.Database, this.selected_tab, setVariable).subscribe((data: Array<any>) => {
      this.tableOpt = data;
      this.renderer();
    });
  }
}
